import {Icon, Input, InputGroup, InputLeftElement, NumberInput} from "@chakra-ui/react";
import { useState } from "react";
import BarcodeScannerModal from "./BarcodeScannerModal";
import { MdOutlineDocumentScanner } from "react-icons/md";

interface InputWithBarcode {
  value: string;
  setValue: (data: string) => void;
  isRequired?: boolean;
  placeholder: string;
  isDisabled?: boolean;
}

const InputWithBarcode = (props: InputWithBarcode) => {
  const [open, setOpen] = useState<boolean>(false);
  
  return (
    <InputGroup size='md'>
      <BarcodeScannerModal
        open={open}
        onClose={() => setOpen(false)}
        onRead={(data) => props.setValue(data)}
      />
      <InputLeftElement onClick={() => {
          if(!props.isDisabled) setOpen(true)
        }}
      >
        <Icon as={MdOutlineDocumentScanner} className="m-2"/>
      </InputLeftElement>
      <Input
        isRequired={props.isRequired}
        pr='4.5rem'
        inputMode="numeric"
        isDisabled={props.isDisabled}
        value={props.value}
        onScroll={(e) => e.preventDefault()}
        onChange={(e) => props.setValue(e.target.value)}
        placeholder={props.placeholder}
      />
    </InputGroup>
  )
};

export default InputWithBarcode;